import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// import './compiled/View404.css';

export default class View404 extends Component {
  // Render
  render() {
    let sad_emoji = (
      <span role="img" aria-label="sad face">
        😨
      </span>
    );

    return (
      <div className="View404 section">
        <div className="container">
          <h2>Unknown Page {sad_emoji}</h2>
          <p>You reached an unknown page.</p>
          <p>
            <Link to="/">Go to home.</Link>
          </p>
        </div>
      </div>
    );
  }
}
